import { number, object } from "superstruct";

const OffsetPaginationMetaSchema = object({
    perPage: number(),
    totalCount: number(),
    currentOffset: number(),
});

export default OffsetPaginationMetaSchema;
